var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 4C6.75 3.58579 7.08579 3.25 7.5 3.25L21 3.25C21.4142 3.25 21.75 3.58579 21.75 4C21.75 4.41421 21.4142 4.75 21 4.75L7.5 4.75C7.08579 4.75 6.75 4.41421 6.75 4ZM2.25 9.33333C2.25 8.91912 2.58579 8.58333 3 8.58333L21 8.58333C21.4142 8.58333 21.75 8.91912 21.75 9.33333C21.75 9.74755 21.4142 10.0833 21 10.0833L3 10.0833C2.58579 10.0833 2.25 9.74755 2.25 9.33333ZM6.75 14.6667C6.75 14.2525 7.08579 13.9167 7.5 13.9167H21C21.4142 13.9167 21.75 14.2525 21.75 14.6667C21.75 15.0809 21.4142 15.4167 21 15.4167H7.5C7.08579 15.4167 6.75 15.0809 6.75 14.6667ZM2.25 20C2.25 19.5858 2.58579 19.25 3 19.25H21C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextRight);
export default __webpack_public_path__ + "static/media/Text-right.5c0d58fa0a6c4ec00c859dd30384c406.svg";
export { ForwardRef as ReactComponent };